import { render, staticRenderFns } from "./sessionview.vue?vue&type=template&id=37684ee1&"
import script from "./sessionview.vue?vue&type=script&lang=ts&"
export * from "./sessionview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports